const _ = require("lodash");

main();

async function main() {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code') || urlParams.get('Code');
    const configuration = await fetchConfiguration(code);
    console.log(configuration);
    if (configuration?.Json) {
        exportJsonFile(configuration.Json, code);
        window.close();
    } else {
        alert("No JSON-Export for this Configurator.")
    }
}

async function fetchConfiguration(code) {
    const backendURL = SETTINGS.wkfgBackendUrl;
    const response = await (await (fetch(`${backendURL}metamodell/config?Code=${code}&metamodel=false&metadata=false&settings=false`))).json();
    return response?.Konfiguration?.pop();
}

function exportJsonFile(data, filename) {
    // Convert Object to JSON
    const convertToFixed = (data) => {
        _.forEach(data, (v, k) => {
            if(typeof v == "object") convertToFixed(v);
            if(typeof v == "number") data[k] = Number.parseFloat(v.toFixed(2));
        });
    }
    convertToFixed(data['preis']);

    data.partsList?.schraenke?.forEach( schrank => {
        schrank.parts?.forEach( part => {
            part.parts?.forEach( internalPart => {
                delete internalPart.Beschreibung;
            });
        });
    });
    
    var jsonString = JSON.stringify(data);

    var exportedFilename = filename + ".json" || "export.json";

    var blob = new Blob([jsonString], { type: "application/json;charset=utf-8;" });
    if (navigator.msSaveBlob) {
        // IE 10+
        navigator.msSaveBlob(blob, exportedFilename);
    } else {
        var link = document.createElement("a");
        if (link.download !== undefined) {
            // feature detection
            // Browsers that support HTML5 download attribute
            var url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", exportedFilename);
            link.style.visibility = "hidden";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
}
